import { FormControl, FormLabel, InputAdornment, MenuItem, OutlinedInput, Select, TextField, styled } from "@mui/material";
import { useController } from "react-hook-form";
import { ToggleTab, ToggleTabs } from "../MuiCustomComponent/MuiCustomComponent";
import Switch from '@mui/material/Switch';
import { DatePicker, LocalizationProvider } from "@mui/x-date-pickers";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import dayjs from "dayjs";
import {  PatternFormat } from "react-number-format";
import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";
import React,{ useEffect, useState } from "react";
import { commonConstants } from "../../common/constants";
const PatternFormatFunction = React.forwardRef(function PatternFormatFunction(props,ref) {
    const { onChange, value, format, ...other } = props;
   
    return (<PatternFormat
    {...other}
    getInputRef={ref}
    format={format}
    onChange={onChange}
    value={value}
    />)
});
export const FormTextField = ({ control, name, id, variant, label, size, fullWidth, rules, sx, className, maxLength, disabled, onBlur }) => {
    const { field, fieldState: { error} } = useController({ name, control, rules });
    return (
        <div onBlur={onBlur}>
            <TextField
                onChange={field.onChange}
                onBlur={field.onBlur}
                value={field.value}
                name={field.name}
                id={id}
                sx={sx}
                className={className}
                fullWidth={fullWidth}
                variant={variant}
                label={label}
                disabled={disabled}
                size={size}
                error={!!error}
                inputProps={{ maxLength: maxLength }}
                inputRef={field.ref}
            aria-invalid={error ? "true" : "false"}
            />
        </div>
    );
};
export const FormTextHeightField = ({ control, name, id, variant, label, size, fullWidth, rules, sx }) => {
    const { field, fieldState: { error } } = useController({ name, control, rules });
    const [format, setFormat] = useState(`##'`);
    useEffect(() => {
        if (field.value) {
            if (field.value.replace('\"', '').replace('\'', '').trim('').length <= 1) {
                setFormat(`#'#`);
            }
            else if (field.value.replace('\"', '').replace('\'', '').trim('').length === 2) {
                setFormat(`#'#"##`);
            }
             else if (field.value.replace('\"', '').replace('\'', '').trim('').length === 3) {
                setFormat(`#'##"#`);
            }
            else if (field.value.replace('\"', '').replace('\'', '').trim('').length > 3) {
                setFormat(`#'##"`);
            }
        }
    }, [field.value]);
    return (
        <TextField
            onBlur={field.onBlur}
            onChange={field.onChange}
            value={field.value}
            name={field.name}
            data-testid={field.name}
            id={id}
            sx={sx}
            fullWidth={fullWidth}
            variant={variant}
            label={label}
            size={size}
            inputProps={{format:format}}
            error={!!error}
            inputRef={field.ref}
            InputProps={{
                inputComponent: PatternFormatFunction
            }}
            aria-invalid={error ? "true" : "false"}
        />
    );
};
export const FormTabField = ({ control, name, id, ariaLabel, label, value, rules, className, disabled , sx})=>{
    const {field,fieldState:{error}}= useController({name,control,rules});
    const handleFieldChange = (e, newValue) => {
        field.onChange(newValue);
    };
    return(
        <ToggleTabs onBlur={field.onBlur} sx={sx} value={field.value} className={className} disabled={disabled} name={field.name} id={id} onChange={handleFieldChange} aria-label={ariaLabel} aria-invalid={error ?"true":"false"}>
            {value.map((item,index)=>{
                return(
                    <ToggleTab sx={{ width: '50%' }} disabled={disabled} key={item} value={item} label={label[index]}  />
                )
            }           
              
           )}
        </ToggleTabs>
    )
}

export const FormDatePicker = ({ control, name, rules, sx, currentDate, disabled, className, maxDays = 1, isDisableFuture = true }) =>{
    const checkDateValid = (value) => {
        const currentDateValue = new Date(value);
        return value && value?.toLocaleString() != commonConstants?.invalidDate && value?.$y < commonConstants?.maxValidDate && value?.$y > commonConstants?.minValidDate && new Date(tomorrow).getTime() > currentDateValue.getTime()
    }

    const datepickerRules = {...rules, validate:{isDateValid:checkDateValid}}
    const { field, fieldState:{ error, isTouched, isDirty, invalid} } = useController({ name, control, rules: datepickerRules });

    const tomorrow = dayjs().add(maxDays, 'day');

    return (
        <div>
            <LocalizationProvider  dateAdapter={AdapterDayjs} >
                <DatePicker slotProps={{ textField: { fullWidth: true, variant: 'outlined', error: (!!error) }}} sx={sx} name={field.name} className={className} value={field.value} disabled={disabled} inputRef={field.ref} onChange={(newValue) => field.onChange(newValue)} disableFuture={isDisableFuture ? true : false} maxDate={tomorrow}  />
        </LocalizationProvider>
        <div>
            {(invalid || isDirty || isTouched) && error?.type == "isDateValid" && <FormLabel error>Please enter a valid date</FormLabel>}
            </div>
        </div>
    )
}
export const FormOutlinedInput = ({ control, type,name, id, variant, size, fullWidth, rules, sx, ariaDescribeBy, position,innerLabel, maxLength, }) => {
    const { field, fieldState: { error } } = useController({ name, control, rules });
    return (
        <FormControl fullWidth={fullWidth} variant={variant} size={size} sx={sx}>
            <OutlinedInput
                value={field.value}
                onChange={field.onChange}
                name={field.name}
                onBlur={field.onBlur}
                type={type}
                error={!!error}
                id={id}
                inputProps={{ maxLength: maxLength }}
                inputRef={field.ref}
                endAdornment={<InputAdornment position={position}>{innerLabel}</InputAdornment>}
                aria-describedby={ariaDescribeBy}
                aria-invalid={error ? "true" : "false"}
                
            />
        </FormControl>
    );
};
export const FormSelectField = ({ control, fullWidth, name, size, id, val, label, rules, className, sx }) => {
    const { field, fieldState: { error } } = useController({ name, control, rules });
    return (
        <FormControl sx={sx} fullWidth={fullWidth} size={size} error={!!error && rules.required} >
            <Select     
                id={id}
                onBlur={field.onBlur}
                inputRef={field.ref}
                IconComponent={KeyboardArrowDownIcon}
                value={field.value}
                onChange={field.onChange}
                className={className}
            >
                {val.map((item,index)=>{
                    return(
                        <MenuItem key={item} value={item}>{label[index]}</MenuItem>
                    )
                })
                }
            </Select>
        </FormControl >
    );
};
export const FormPhoneNumberField = ({ control, name, id, variant, label, size, fullWidth, rules, sx, disabled,className }) => {
    const { field, fieldState: { error } } = useController({ name, control, rules });
    const format = `(###) ### - ####`;
    return (
        <TextField
            onBlur={field.onBlur}
            onChange={field.onChange}
            value={field.value}
            name={field.name}
            disabled={disabled}
            className={className}
            id={id}
            sx={sx}
            fullWidth={fullWidth}
            variant={variant}
            label={label}
            size={size}
            inputProps={{ format: format }}
            error={!!error}
            inputRef={field.ref}
            InputProps={{
                inputComponent: PatternFormatFunction
            }}
            aria-invalid={error ? "true" : "false"}
        />
    );
};
export const FormPhoneNumberExtension = ({ control, name, id, variant, label, size, fullWidth, rules, sx,disabled,className }) => {
    const { field, fieldState: { error } } = useController({ name, control, rules });
    const format = '####';
    return (
        <TextField
            onBlur={field.onBlur}
            onChange={field.onChange}
            value={field.value}
            name={field.name}
            id={id}
            className={className}
            sx={sx}
            fullWidth={fullWidth}
            disabled={disabled}
            variant={variant}
            label={label}
            size={size}
            inputProps={{ format: format }}
            error={!!error}
            inputRef={field.ref}
            InputProps={{
                inputComponent: PatternFormatFunction
            }}
            aria-invalid={error ? "true" : "false"}
        />
    );
};
export const FormZipCode = ({ control, name, id, variant, label, size, fullWidth, rules, sx ,className, disabled }) => {
    const { field, fieldState: { error } } = useController({ name, control, rules });
    const format = '#####';
    return (
        <TextField
            onBlur={field.onBlur}
            onChange={field.onChange}
            value={field.value}
            className={className}
            disabled={disabled}
            name={field.name}
            id={id}
            sx={sx}
            fullWidth={fullWidth}
            variant={variant}
            label={label}
            size={size}
            inputProps={{ format: format }}
            error={!!error}
            inputRef={field.ref}
            InputProps={{
                inputComponent: PatternFormatFunction
            }}
            aria-invalid={error ? "true" : "false"}
        />
    );
};
export const FormNumberOutlinedField = ({ control, numberFormat, name, id, variant, size, fullWidth, rules, sx, ariaDescribeBy, position, innerLabel, max }) => {
    const { field, fieldState: { error } } = useController({ name, control, rules });
    return (
        <FormControl fullWidth={fullWidth} variant={variant}  size={size} sx={sx}>
            <OutlinedInput
                value={field.value}
                onChange={field.onChange}
                name={field.name}
                data-testid={field.name}
                onBlur={field.onBlur}
                error={!!error}
                id={id}
                inputProps={{ format: numberFormat }}
                inputComponent={PatternFormatFunction}
                inputRef={field.ref}
                endAdornment={<InputAdornment position={position}>{innerLabel}</InputAdornment>}
                aria-describedby={ariaDescribeBy}
                aria-invalid={error ? "true" : "false"}
            />
        </FormControl>
    );
};

export const FormAntSwitch = ({ name, control, rules, inputProps, id, sx }) => {
    const { field } = useController({ name, control, rules });
    return(
        <Switch sx={sx} checked={field.value} id={id} onChange={(e)=>field.onChange(e.target.checked)} name={field.name} inputProps={inputProps}/>
    )
}

export const CustomFormTextfield = styled(FormTextField)(() => ({
    '.MuiInputBase-root ': { padding: '0px', },
    '.MuiOutlinedInput-root ': { borderRadius: "8px", }
  }));
  
  export const CustomPhoneFormTextfield = styled(FormPhoneNumberField)(() => ({
    '.MuiInputBase-root ': { padding: '0px', },
    '.MuiOutlinedInput-root ': { borderRadius: "8px", }
  }));